import { CourtDecisionType, type CourtDecision } from '../../../../types/LegalCase';

export interface GroupedDecisions {
    origins: CourtDecision[];
    appealByOrigin: Map<string, CourtDecision>;
    orphans: CourtDecision[];
}

// Agrupa as decisões para exibição: cada decisão de origem (não-recurso) carrega o recurso
// vinculado logo abaixo (relação origem → recurso, um sentido). Recursos órfãos (cuja origem
// não está na lista — não deveria ocorrer depois da cascata de remoção e do invariante do
// backend, mas é defensivo) caem numa lista à parte, exibida no fim, para não sumirem da tela.
//
// Classificação em passe único e **mutuamente exclusiva**, para nenhum item ser renderizado
// duas vezes: um APPEAL_FILED nunca entra em `origins`. Se aponta para uma origem presente na
// lista, vincula-se a ela (`appealByOrigin`); senão (sem vínculo, ou origem ausente) é órfão.
// Só as decisões comuns são origens.
export const groupDecisions = (decisions: CourtDecision[]): GroupedDecisions => {
    const appealByOrigin = new Map<string, CourtDecision>();
    const origins: CourtDecision[] = [];
    const orphans: CourtDecision[] = [];
    const ids = new Set(decisions.map((d) => d.id));

    for (const d of decisions) {
        if (d.decisionType === CourtDecisionType.APPEAL_FILED) {
            if (d.relatedDecisionId && ids.has(d.relatedDecisionId)) {
                appealByOrigin.set(d.relatedDecisionId, d);
            } else {
                orphans.push(d);
            }
        } else {
            origins.push(d);
        }
    }

    return { origins, appealByOrigin, orphans };
};
